import React from 'react';
import Navbar from '../Navbar.jsx';
import Home from './Home.jsx';

const Dashboard = () => {
    return (
        <>
            <Navbar/>
            <Home/>
        </>
    );
};

export default Dashboard;